 import BASEURLGESTTOR from '../api/gesttor'
import { BASEAPIGESTTORAUTH } from '../api/gesttor'
import { payloadLoginGoogle } from '../../interfaces/google'

export function criarAcessoaAgenda () {
    return BASEURLGESTTOR.post(`/google-agenda/auth`)
}

export function sincronizarAgenda () {
    return BASEURLGESTTOR.post(`/google-agenda/sincronizacao`)
}

export function authGoogle () {
    return BASEAPIGESTTORAUTH.get('/google-auth')
}

export function authGoogleConfirmacao (payload: { code: string }) {
    return BASEAPIGESTTORAUTH.post(`/google-auth/confirmacao`, payload)
}

export function loginGoogle (payload: payloadLoginGoogle) {
    return BASEAPIGESTTORAUTH.post('/google-auth', payload)
}